module.exports = __webpack_public_path__ + "img/tracking.svg";